
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">           
            <group-edit *ngSwitchCase="true"></group-edit>
            <group-details *ngSwitchCase="false"></group-details>
        </div>
    </ng-template>  
</main-form-modal>